import {AppProperty} from "../../../javascript.lib.mojo-base/model/AppProperty";


export class UserPropertyView {

  constructor(public property: AppProperty, public include: boolean ) {
  }
}
